import React from "react";
import { Link } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";

const Breadcrumbs: React.FC = () => {
  const {
    globalState: { breadcrumbs },
  } = useGlobalState();
  return (
    <>
      {/* {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="app-breadcrumb">
          <ul>
            {breadcrumbs.map((breadcrumb, i) => (
              <li key={"_breadcrumb" + i}>
                {breadcrumb.path !== null ? <Link to={breadcrumb.path}>{breadcrumb.label}</Link> : <a>{breadcrumb.label}</a>}
                <span></span>
              </li>
            ))}
          </ul>
        </div>
      )} */}
      <div className="nav-breadcrumb"></div>
    </>
  );
};

export default Breadcrumbs;
